export const setLoggedIn = (loggedIn) => (dispatch) => {
  if (loggedIn) dispatch({ type: 'SET_LOGGED_IN', payload: loggedIn })
}
